<ng-container>
  <ng-container *ngIf="!(redirectToIssuerLoading$ | async); else loading">
    <bca-tab-stepper
      [highestRoute]="highestRoute$ | async"
      [currentRoute]="currentRoute$ | async"
      (tabClicked)="onTabClicked($event)"
    >
      <ng-container *ngFor="let page of pageData">
        <bca-tab
          [done]="(currentRoute$ | async) > page.route"
          [active]="(currentRoute$ | async) === page.route"
          [route]="page.route"
          [title]="page.title | translate"
        >
        </bca-tab>
      </ng-container>
    </bca-tab-stepper>

    <div class="nes-grid sm:nes-grid-cols-1 lg:nes-grid-cols-3 nes-my-5 content-grid">
      <div class="sm:nes-col-span-1 lg:nes-col-span-2 tile" style="border-top: none; box-shadow: none; padding-top: 0;">
        <ng-container [ngSwitch]="currentRoute$ | async">
          <bca-products-overview
            *ngSwitchCase="Route.COMPOSE"
          ></bca-products-overview>
          <bca-user-data *ngSwitchCase="Route.USER_DATA"></bca-user-data>
          <bca-company-data
            *ngSwitchCase="Route.COMPANY_DATA"
          ></bca-company-data>
          <bca-verify *ngSwitchCase="Route.VERIFY"></bca-verify>
          <bca-agreement *ngSwitchCase="Route.AGREEMENT"></bca-agreement>
        </ng-container>

        <!-- Mobile: Agreement step — cart + org-details (hidden on desktop) -->
        <ng-container *ngIf="(currentRoute$ | async) === Route.AGREEMENT">

          <div class="mobile-agreement-cart lg:nes-hidden"
               *ngIf="(cartProducts$ | async)?.length > 0">
            <aside class="order-cart">
              <h3 class="cart-title">
                <span class="cart-title__line1">{{ 'VERIFY.CART.TITLE' | translate }}</span>
                <span class="cart-title__line2">{{ confirmedProductCount$ | async }} NS-Business Card{{ (confirmedProductCount$ | async) > 1 ? 's' : '' }}</span>
              </h3>

              <ng-container *ngFor="let product of cartProducts$ | async">
                <div class="cart-product-box">
                  <div class="cart-row cart-row--name" *ngIf="product.user">
                    <span>{{ product.user | displayName | async }}</span>
                  </div>
                  <div class="cart-row">
                    <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
                    <span>€ {{ product.price | priceFormat }}</span>
                  </div>
                  <ng-container *ngFor="let addon of product.addons">
                    <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="cart-row">
                      <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
                      <span>€ {{ addon.price | priceFormat }}</span>
                    </div>
                    <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="cart-row">
                      <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
                      <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <div class="cart-subtotals">
                <div class="cart-row">
                  <span>{{ 'VERIFY.SUBTOTAL' | translate }}</span>
                  <span>€ {{ cartSubTotalReceiptPrice$ | async | priceFormat }}</span>
                </div>
                <div class="cart-row">
                  <span>{{ 'VERIFY.TAX_PRICE' | translate }}</span>
                  <span>€ {{ cartTax$ | async | priceFormat }}</span>
                </div>
              </div>

              <hr class="cart-separator" />

              <div class="cart-total-row">
                <span>{{ 'FREQUENTION.MONTH_TOTAL' | translate }}</span>
                <span>€ {{ cartTotalReceiptPrice$ | async | priceFormat }}</span>
              </div>

              <nes-button
                variant="secondary"
                nes-id="mobile_edit_order"
                (click)="navigateToOverview()"
              >
                {{ 'VERIFY.BUTTON.EDIT_ORDER' | translate }}
              </nes-button>
            </aside>
          </div>

          <div class="mobile-agreement-org-details lg:nes-hidden"
               *ngIf="company$ | async as company">
            <div class="org-details-card">

              <div class="org-details-section">
                <h4 class="org-details-title">{{ 'VERIFY.ORGANISATION_DETAILS' | translate }}</h4>
                <p class="org-details-body">{{ company.name }}</p>
                <p class="org-details-body">KVK-nummer {{ company.kvkNumber }}</p>
                <p class="org-details-body">
                  {{ company.address.street }} {{ company.address.houseNumber }}
                </p>
                <p class="org-details-body">
                  {{ company.address.postcode }} {{ company.address.city }}
                </p>
              </div>

              <div class="org-details-section" *ngIf="company.representative as rep">
                <h4 class="org-details-title">{{ 'VERIFY.REPRESENTATIVE' | translate }}</h4>
                <p class="org-details-body">{{ rep | displayName | async }}</p>
                <p class="org-details-body">{{ rep.email }}</p>
              </div>

              <div class="org-details-section">
                <h4 class="org-details-title">{{ 'VERIFY.CONTACT_PERSON' | translate }}</h4>
                <ng-container *ngIf="company.contactPerson as cp; else repAsContactMobile">
                  <p class="org-details-body">{{ cp | displayName | async }}</p>
                  <p class="org-details-body">{{ cp.email }}</p>
                </ng-container>
                <ng-template #repAsContactMobile>
                  <p class="org-details-body">{{ company.representative | displayName | async }}</p>
                  <p class="org-details-body">{{ company.representative?.email }}</p>
                </ng-template>
              </div>

              <button type="button" class="org-details-edit-link" (click)="navigateToCompanyData()">
                <nes-icon name="edit" aria-hidden="true"></nes-icon>
                {{ 'VERIFY.BUTTON.EDIT_COMPANY' | translate }}
              </button>

            </div>
          </div>

        </ng-container>

        <div class="product-info-wrapper" *ngIf="(currentRoute$ | async) !== Route.VERIFY && (currentRoute$ | async) !== Route.COMPANY_DATA && (currentRoute$ | async) !== Route.AGREEMENT">
          <ns-product-info (action)="onActionClicked($event)"></ns-product-info>
        </div>
        <div class="mobile-usp-block lg:nes-hidden" *ngIf="(currentRoute$ | async) !== Route.VERIFY && (currentRoute$ | async) !== Route.COMPANY_DATA && (currentRoute$ | async) !== Route.AGREEMENT">
          <bca-usp-block></bca-usp-block>
        </div>
      </div>

      <div class="nes-col-span-1">
        <ng-container *ngIf="(cartProducts$ | async)?.length > 0">
          <div [stickyReceipt]="true" class="cart-column-wrapper nes-hidden lg:nes-flex nes-flex-col">
            <aside class="order-cart">
              <h3 class="cart-title">
                <span class="cart-title__line1">{{ 'VERIFY.CART.TITLE' | translate }}</span>
                <span class="cart-title__line2">{{ confirmedProductCount$ | async }} NS-Business Card{{ (confirmedProductCount$ | async) > 1 ? 's' : '' }}</span>
              </h3>

              <ng-container *ngFor="let product of cartProducts$ | async">
                <div class="cart-product-box">
                  <div class="cart-row cart-row--name" *ngIf="product.user">
                    <span>{{ product.user | displayName | async }}</span>
                  </div>
                  <div class="cart-row">
                    <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
                    <span>€ {{ product.price | priceFormat }}</span>
                  </div>
                  <ng-container *ngFor="let addon of product.addons">
                    <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="cart-row">
                      <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
                      <span>€ {{ addon.price | priceFormat }}</span>
                    </div>
                    <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="cart-row">
                      <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
                      <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <div class="cart-subtotals">
                <div class="cart-row">
                  <span>{{ 'VERIFY.SUBTOTAL' | translate }}</span>
                  <span>€ {{ cartSubTotalReceiptPrice$ | async | priceFormat }}</span>
                </div>
                <div class="cart-row">
                  <span>{{ 'VERIFY.TAX_PRICE' | translate }}</span>
                  <span>€ {{ cartTax$ | async | priceFormat }}</span>
                </div>
              </div>

              <hr class="cart-separator" />

              <div class="cart-total-row">
                <span>{{ 'FREQUENTION.MONTH_TOTAL' | translate }}</span>
                <span>€ {{ cartTotalReceiptPrice$ | async | priceFormat }}</span>
              </div>

              <!-- Step 1 or 2: navigate directly to Besteloverzicht — desktop only (mobile uses floating cart modal) -->
              <nes-button
                *ngIf="(currentRoute$ | async) < Route.VERIFY"
                [cypress]="'next_page'"
                variant="brand"
                icon-leading="cart"
                nes-id="to_besteloverzicht_page"
                id="to_besteloverzicht_page"
                (click)="goToBesteloverzicht()"
              >
                @if ((confirmedProductCount$ | async) === 1) {
                  {{ 'BUTTON.BESTEL_KAART_ONE' | translate }}
                } @else {
                  {{ 'BUTTON.BESTEL_KAART_MANY' | translate: { count: (confirmedProductCount$ | async) } }}
                }
              </nes-button>

              <!-- Besteloverzicht: continue to next step — desktop only -->
              <nes-button
                *ngIf="(currentRoute$ | async) === Route.VERIFY"
                [cypress]="'next_page'"
                variant="brand"
                icon-trailing="true"
                nes-id="to_agreement_page"
                id="to_agreement_page"
                (click)="nextRoute()"
              >
                {{ 'VERIFY.BUTTON.CONTINUE_ORDER' | translate }}
              </nes-button>

              <!-- Company data step: Wijzig bestelling navigates back to Besteloverzicht — desktop only -->
              <nes-button
                *ngIf="(currentRoute$ | async) === Route.COMPANY_DATA"
                [cypress]="'next_page'"
                variant="secondary"
                nes-id="to_besteloverzicht_from_company_data"
                id="to_besteloverzicht_from_company_data"
                (click)="navigateToOverview()"
              >
                {{ 'VERIFY.BUTTON.EDIT_ORDER' | translate }}
              </nes-button>

              <!-- Agreement step: Wijzig bestelling navigates back to Besteloverzicht —  desktop only -->
              <nes-button
                *ngIf="(currentRoute$ | async) === Route.AGREEMENT"
                [cypress]="'next_page'"
                variant="secondary"
                nes-id="to_besteloverzicht_from_agreement"
                id="to_besteloverzicht_from_agreement"
                (click)="navigateToOverview()"
              >
                {{ 'VERIFY.BUTTON.EDIT_ORDER' | translate }}
              </nes-button>
            </aside>

            <!-- USP block shown below cart on step 1 and 2 — desktop only -->
            <div
              class="usp-block-wrapper"
              *ngIf="(currentRoute$ | async) < Route.VERIFY"
            >
              <bca-usp-block></bca-usp-block>
            </div>

            <!-- Organisation details card — Agreement step only -->
            <ng-container *ngIf="(currentRoute$ | async) === Route.AGREEMENT">
              <div class="org-details-card" *ngIf="company$ | async as company">

                <div class="org-details-section">
                  <h4 class="org-details-title">{{ 'VERIFY.ORGANISATION_DETAILS' | translate }}</h4>
                  <p class="org-details-body">{{ company.name }}</p>
                  <p class="org-details-body">KVK-nummer {{ company.kvkNumber }}</p>
                  <p class="org-details-body">
                    {{ company.address.street }} {{ company.address.houseNumber }}
                  </p>
                  <p class="org-details-body">
                    {{ company.address.postcode }} {{ company.address.city }}
                  </p>
                </div>

                <div class="org-details-section" *ngIf="company.representative as rep">
                  <h4 class="org-details-title">{{ 'VERIFY.REPRESENTATIVE' | translate }}</h4>
                  <p class="org-details-body">{{ rep | displayName | async }}</p>
                  <p class="org-details-body">{{ rep.email }}</p>
                </div>

                <div class="org-details-section">
                  <h4 class="org-details-title">{{ 'VERIFY.CONTACT_PERSON' | translate }}</h4>
                  <ng-container *ngIf="company.contactPerson as cp; else repAsContact">
                    <p class="org-details-body">{{ cp | displayName | async }}</p>
                    <p class="org-details-body">{{ cp.email }}</p>
                  </ng-container>
                  <ng-template #repAsContact>
                    <p class="org-details-body">{{ company.representative | displayName | async }}</p>
                    <p class="org-details-body">{{ company.representative?.email }}</p>
                  </ng-template>
                </div>

                <button type="button" class="org-details-edit-link" (click)="navigateToCompanyData()">
                  <nes-icon name="edit" aria-hidden="true"></nes-icon>
                  {{ 'VERIFY.BUTTON.EDIT_COMPANY' | translate }}
                </button>

              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="(currentRoute$ | async) < Route.VERIFY && !((cartProducts$ | async)?.length > 0)">
          <div
            [stickyReceipt]="stickyReceipt$ | async"
            class="cart-column-wrapper nes-hidden lg:nes-flex nes-flex-col"
          >
            <ng-container *ngIf="(currentRoute$ | async) > Route.USER_DATA">
              <bca-receipt> </bca-receipt>
            </ng-container>

            <div class="usp-block-wrapper">
              <bca-usp-block></bca-usp-block>
            </div>
          </div>

          <ng-container *ngIf="(currentRoute$ | async) > Route.USER_DATA">
            <bca-receipt-footer
              class="nes-fixed nes-bottom-0 nes-right-0 nes-left-0 lg:nes-hidden nes-z-raised"
              (open)="onReceiptOpened()"
              [totalProductCount]="totalProductCount$ | async"
              [totalReceiptPrice]="totalReceiptPrice$ | async"
            >
            </bca-receipt-footer>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Floating cart button + modal — mobile only, shown on step 1 (Samenstellen) and step 2 (Gebruikersgegevens) -->
    <ng-container *ngIf="(currentRoute$ | async) <= Route.USER_DATA && (cartProducts$ | async)?.length > 0">
      <button class="floating-cart-btn lg:nes-hidden" (click)="openCartModal()" type="button" aria-label="Winkelwagen openen">
        <nes-icon name="cart" resize="24" class="floating-cart-icon" aria-hidden="true"></nes-icon>
        <span class="floating-cart-badge">{{ confirmedProductCount$ | async }}</span>
      </button>

      <div *ngIf="cartModalOpen" class="cart-modal-overlay lg:nes-hidden" (click)="closeCartModal()">
        <div class="cart-modal" (click)="$event.stopPropagation()">
          <aside class="order-cart">
            <h3 class="cart-title">
              <span class="cart-title__line1">{{ 'VERIFY.CART.TITLE' | translate }}</span>
              <span class="cart-title__line2">{{ totalProductCount$ | async }} NS-Business Card{{ (totalProductCount$ | async) > 1 ? 's' : '' }}</span>
            </h3>

            <div class="cart-products-list">
              <ng-container *ngFor="let product of cartProducts$ | async">
                <div class="cart-product-box">
                  <div class="cart-row cart-row--name" *ngIf="product.user">
                    <span>{{ product.user | displayName | async }}</span>
                  </div>
                  <div class="cart-row">
                    <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
                    <span>€ {{ product.price | priceFormat }}</span>
                  </div>
                  <ng-container *ngFor="let addon of product.addons">
                    <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="cart-row">
                      <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
                      <span>€ {{ addon.price | priceFormat }}</span>
                    </div>
                    <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="cart-row">
                      <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
                      <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <div class="cart-subtotals">
                <div class="cart-row">
                  <span>{{ 'VERIFY.SUBTOTAL' | translate }}</span>
                  <span>€ {{ cartSubTotalReceiptPrice$ | async | priceFormat }}</span>
                </div>
                <div class="cart-row">
                  <span>{{ 'VERIFY.TAX_PRICE' | translate }}</span>
                  <span>€ {{ cartTax$ | async | priceFormat }}</span>
                </div>
              </div>

              <hr class="cart-separator" />

              <div class="cart-total-row">
                <span>{{ 'FREQUENTION.MONTH_TOTAL' | translate }}</span>
                <span>€ {{ cartTotalReceiptPrice$ | async | priceFormat }}</span>
              </div>
            </div>

            <hr class="cart-separator cart-separator--before-btn" />

            <button type="button" class="cart-modal-order-btn" (click)="goToBesteloverzicht()">
              <nes-icon name="cart" class="cart-modal-btn-icon" aria-hidden="true"></nes-icon>
              <span class="cart-modal-btn-text">
                @if ((confirmedProductCount$ | async) === 1) {
                  {{ 'BUTTON.BESTEL_KAART_ONE' | translate }}
                } @else {
                  {{ 'BUTTON.BESTEL_KAART_MANY' | translate: { count: (confirmedProductCount$ | async) } }}
                }
              </span>
              <span class="cart-modal-btn-spacer" aria-hidden="true"></span>
            </button>

            <span class="cart-modal-close-link" (click)="closeCartModal()">
              {{ 'BUTTON.SLUIT_SCHERM' | translate }}
            </span>
          </aside>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 4rem;
      "
    >
      <h3
        style="display: flex; justify-content: center"
        class="headingS loader-tekst"
      >
        {{ "AGREEMENT.ISSUER_LOADING" | translate }}
      </h3>
      <div class="basicLoader"></div>
    </div>
  </ng-template>
  <nes-sticky-footer id="sticky-footer-component">
    <div
      class="nes-flex nes-gap-4 nes-items-center nes-justify-between nes-h-[42px]"
    >
      <nes-price price="33" leading-text="prijs" stacked size="xl"></nes-price>
      <nes-button variant="brand"> Koop kaartje </nes-button>
    </div>
  </nes-sticky-footer>
</ng-container>
